export function $<T extends Element = HTMLElement>(selector: string, root: ParentNode = document): T {
  const el = root.querySelector<T>(selector)
  if (!el) throw new Error(`Missing element: ${selector}`)
  return el
}

export function $$<T extends Element = HTMLElement>(selector: string, root: ParentNode = document): T[] {
  return Array.from(root.querySelectorAll<T>(selector))
}

const ESCAPES: Record<string, string> = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }

export const esc = (value: string): string => value.replace(/[&<>"']/g, (ch) => ESCAPES[ch])

export const pad = (n: number): string => String(n).padStart(2, '0')

export const icon = (id: string, className = ''): string =>
  `<svg class="${className}" aria-hidden="true"><use href="#${id}"></use></svg>`

/** Resolve a media path from portfolio data against the deployed base URL. */
export function mediaUrl(path: string): string {
  if (/^(https?:)?\/\//.test(path) || path.startsWith('data:')) return path
  return import.meta.env.BASE_URL + path.replace(/^\/+/, '')
}
